<template>
  <router-view></router-view>
  <footer-two v-if="showFooter"></footer-two>
</template>

<script>
export default {
  computed: {
    showFooter() {
      // Halaman grading full-workspace — footer site tidak diperlukan
      return !this.$route.path.includes("instructor-exam-grading");
    },
  },
};
</script>
